import { Component, Input } from '@angular/core';
import { Avatar } from '../../models/avatar.model';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {

  @Input()
  avatar: Avatar;

  constructor() {
  }

}
